module.exports = __webpack_public_path__ + "img/20201017.b56f58d9.png";